import React from 'react';
import Link from 'gatsby-link';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import MonzoLogo from 'marketing-website/components/icons/MonzoRound';
import Image from 'marketing-website/components/modules/Image';
import ArrowLink from 'marketing-website/components/commons/ArrowLink';

import primaryImageRetina from 'marketing-website/media/images/pages/financial-services/monzo-1@2x.jpg';
import secondaryImageRetina from 'marketing-website/media/images/pages/financial-services/monzo-2@2x.jpg';

import styles from './style/monzo-upsell.module.css';

export default function MonzoUpsell() {
  return (
    <div>
      <div className={styles.wrap}>
        <div className={styles.top}>
          <MaxWidth value={485} display="inlineBlock">
            <Heading tag="h3" color="black" size="xxxxl" weight="semibold">
              See how Marvel keeps Monzo shipping every 2 weeks.
            </Heading>

            <Spacing size="xl" type="margin" position="top">
              <Link to="/case-studies/monzo">
                <ArrowLink size="l" weight="semibold" colour="blue">
                  Read Monzo's case study
                </ArrowLink>
              </Link>
            </Spacing>
          </MaxWidth>
        </div>
      </div>
      <div className={styles.quote}>
        <div className={styles.wrap}>
          <div className={styles.primaryImage}>
            <Image
              alt="See how Marvel keeps Monzo shipping every 2 weeks."
              maxWidth={390}
              src={primaryImageRetina}
              hasShadow
            />
          </div>
          <div className={styles.secondaryImage}>
            <Image
              alt="See how Marvel keeps Monzo shipping every 2 weeks."
              maxWidth={410}
              src={secondaryImageRetina}
              hasShadow={false}
            />
          </div>
          <div className={styles.quoteWrapper}>
            <Spacing size="l" type="margin" position="bottom">
              <MonzoLogo />
            </Spacing>
            <blockquote className={styles.blockquote}>
              “We use Marvel a lot for user testing. Actually being able to
              create a scenario, prepare a flow for a person and have them walk
              through it step-by-step creates such valuable feedback.”
            </blockquote>
            <Spacing size="l" type="margin" position="top">
              <Paragraph size="l" color="silver">
                Hugo C, Head of Design at Monzo
              </Paragraph>
            </Spacing>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/MonzoUpsell/index.js